import {Empty} from "antd";

export const MenuWeekErrorPage = () => {
    return (
        <Empty className={'m-2'} description={'Nie umiezczono jeszcze menu do pobrania na wybrany tydzień'}/>
    )
}